/**
 * Takes a numerator and a denominator and converts it into a floated
 * percentage string. Accounts for situations where the denominator is null
 * or zero and returns "0.0".
 *
 * @param {number} numerator
 * @param {number} denominator
 * @returns {string}
 */
export function formatPercent(numerator, denominator, decimals = 1) {
  if (denominator == null || denominator <= 0)
    return decimals === 0 ? '0' : '0.0';

  return ((numerator / denominator) * 100).toFixed(decimals);
}
